export enum PROJECT_OVERVIEW {
  ID = "projectOverview",
  TITLE = "Request Details",
}

export enum FLYER_PERIOD {
  ID = "flyerPeriod",
  TITLE = "Flyer Period",
}

export enum VENDOR_ASSETS_LOCATION {
  ID = "vendorAssetsLocation",
  TITLE = "Vendor Assets Location",
}

export enum IS_REGIONAL {
  ID = "isRegional",
  TITLE = "Is Regional",
}

export enum HAS_VENDOR_COMMITMENT {
  ID = "hasVendorCommitment",
  TITLE = "Has Vendor Commitment",
}

export enum ARE_VENDOR_ASSETS_PROVIDED {
  ID = "areVendorAssetsProvided",
  TITLE = "Are Vendor Assets Provided",
}

export enum MERCH_OWNERS {
  ID = "merchOwnerDetails",
  TITLE = "Merch Owners",
}

export enum START_DATE {
  ID = "startAt",
  TITLE = "Start Date",
}

export enum END_DATE {
  ID = "endAt",
  TITLE = "End Date",
}

export enum IS_INVENTORY_AVAILABLE {
  ID = "isInventoryAvailable",
  TITLE = "Is Inventory Available",
}

export enum DEALER_STORE_TYPE {
  ID = "storeType",
  TITLE = "Dealer Store Type",
}

export enum STORE_NUMBER {
  ID = "storeNumber",
  TITLE = "Store Number",
}

export enum REQUEST_DETAILS {
  ID = "background",
  TITLE = "Request Details",
}

export enum PROGRAM_OBJECTIVES {
  ID = "programObjectives",
  TITLE = "Program Objectives",
}

export enum BUSINESS_OBJECTIVES {
  ID = "businessObjectives",
  TITLE = "Business Objectives",
}

export enum KEY_MESSAGE {
  ID = "keyMessage",
  TITLE = "Key Message",
}

export enum EXECUTION_DETAILS {
  ID = "executionDetails",
  TITLE = "Execution details",
}

export enum REPORTING_MASTER_CAMPAIGN_NAME {
  ID = "reportingMasterCampaignName",
  TITLE = "Reporting Master Campaign Name",
}

export enum NUMBER_OF_WORK_ORDERS_REQUESTED {
  ID = "numberOfWorkOrdersRequested",
  TITLE = "Number of WorkOrders Requested",
}

export enum CREATIVE_DIRECTION {
  ID = "creativeDirection",
  TITLE = "Overall Creative Direction",
}

export enum COPY_DIRECTION {
  ID = "copyDirection",
  TITLE = "Overall Copy Direction",
}

export enum LANGUAGES {
  ID = "languages",
  TITLE = "Languages",
}
